// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCaseDocumentRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentCaseDocumentRelationshipModel.attributeTypeMap;
    }
}
EnrollmentCaseDocumentRelationshipModel.discriminator = undefined;
EnrollmentCaseDocumentRelationshipModel.additionalProperties = false;
EnrollmentCaseDocumentRelationshipModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "comment",
        "baseName": "comment",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentCaseDocumentRelationshipModel.js.map